// @ts-expect-error
import { Dispatch, useMemo, useState, useTransition } from "react";

type UseTransition = typeof useTransition;

type IsPending = ReturnType<UseTransition>[0];

type StartTransition = ReturnType<UseTransition>[1];

type SetState<S> = Dispatch<S | ((prevState: S) => S)>;

type Options = Parameters<UseTransition>;

interface UseTransitionState<S = any> {
  (initialState?: S, options?: Options): [
    S,
    SetState<S>,
    {
      isPending: IsPending;
      startTransition: StartTransition;
      setState: SetState<S>;
    }
  ];
}

const useTransitionState: UseTransitionState = (initialState, options) => {
  const [state, setState] = useState(initialState);
  const [isPending, startTransition] = useTransition(options);

  return useMemo(
    () => [
      state,
      (nextState) => startTransition(() => setState(nextState)),
      { isPending, startTransition, setState },
    ],
    [startTransition, state]
  );
};

export default useTransitionState;
